import { ColumnsType } from "antd/es/table";
import { Category } from "@types";
import { CategoriesTableActions } from "@components";
import { Translation } from "react-i18next";

export const categoryTable: ColumnsType<Category> = [
    {
        title: <Translation> 
        {
            t => t("table.name")
        }
        </Translation>,
        dataIndex: "name",
        key: "name"
    },
    {
        title: <Translation> 
        {
            t => t("table.parentCategory")
        }
        </Translation>,
        dataIndex: "parentName",
        key: "parentName"
    },
    {
        title: <Translation> 
        {
            t => t("forms.category.forQuiz")
        }
        </Translation>,
        dataIndex: "availableForQuiz",
        key: "availableForQuiz",
        render(checked) {
            return checked ?<Translation> 
            {
                t => t("yes")
            }
            </Translation> : <Translation> 
        {
            t => t("no")
        }
        </Translation>
        }
    },
    {
        title: <Translation> 
        {
            t => t("table.actions")
        }
        </Translation>,
        key: "actions",
        render(_, record) {
            return <CategoriesTableActions category={record}/>
        },
    }
]